import { ErrorFallback } from '@/shared/components/error-fallback';
import { useNavigate } from '@tanstack/react-router';

export function InvalidWorkspaceFallback() {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-0 text-center">
      <ErrorFallback
        title="Expired Workspace"
        description="You cannot access this workspace."
        reset={() => {
          navigate({ to: '/workspace/$workspaceId/settings/plan' });
        }}
        buttonLabel="Go to Plan"
      />
    </div>
  );
}
